import { render, staticRenderFns } from "./CmgBagOfferModal.vue?vue&type=template&id=0d4dbcf0&scoped=true&lang=pug&"
import script from "./cmg-bag-offer-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-bag-offer-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgBagOfferModal.vue?vue&type=style&index=0&id=0d4dbcf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4dbcf0",
  null
  
)

export default component.exports